import AffirmationProgramEntitlementService from 'src/modules/affirmationProgramEntitlement/affirmationProgramEntitlementService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'ENTITLEMENT_VIEW';

const affirmationProgramEntitlementViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type:
          affirmationProgramEntitlementViewActions.FIND_STARTED,
      });

      const record = await AffirmationProgramEntitlementService.find(
        id,
      );

      dispatch({
        type:
          affirmationProgramEntitlementViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type:
          affirmationProgramEntitlementViewActions.FIND_ERROR,
      });

      getHistory().push('/affirmation-program-entitlement');
    }
  },
};

export default affirmationProgramEntitlementViewActions;
